class UserProfile {
    setImageAsDefault(id) {
        app.ajax.post("/services/user/default/image", {id: id}, function (data) {
            this.updateProfileImages(data.image);
            this.setImageMediaActive(id);
        }.bind(this));
    }

    setImageAsBackground(id) {
        app.ajax.post("/services/user/default/image", {id: id, placement: "background"}, function (data) {
            app.ajax.reload("#page");
            this.setImageMediaActive(id);
        }.bind(this));
    }

    setImageMediaActive(id) {
        jQuery(".media-image").removeClass("active-profile-picture");
        jQuery("#media-" + id).addClass("active-profile-picture");
    }

    updateProfileImages(image) {
        app.ajax.reload("#page");
        let elm = document.querySelectorAll('.user-profile-image-small');
        if (elm) {
            for (let i = 0; elm.length > i; i++) {
                elm[i].setAttribute('src', image.profileThumb);
            }
        }
    }

    updateBackgroundImages(images) {
        app.ajax.reload("#page");
    }

    deleteProfile() {
        app.ajax.get('/services/user/delete-confirm', {}, this._deleteProfile.bind(this));
    }

    _deleteProfile(response) {
        if (response.status) {
            app.alert.success(response.header, response.message);
        }
    }
}